module.exports = __webpack_public_path__ + "static/img/4.72f2ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/4.png
// module id = ntVO
// module chunks = 0